module.exports = __webpack_public_path__ + "media/markers/logimg_U-aa4da0f7.png";